import { Component, Vue, Watch, Prop, Ref } from 'vue-property-decorator'
import {
  diagramViews,
  DiagramView,
  DiagramType,
} from '@/diagrams/models/diagram-views'
import Visual from '@/diagrams/models/visual'

import { VMenu } from 'vuetify/lib'

// TODO: registring the hook globally does not work.
Component.registerHooks(['beforeRouteEnter'])

@Component
export default class ProjectDetail extends Vue {
  @Ref()
  private visual!: Visual

  private diagramLayouts = diagramViews
  private selectedLayout = diagramViews.items[0]

  get selectedComponent() {
    switch (this.selectedLayout.type) {
      case DiagramType.Spider:
        return 'spider'
      case DiagramType.MessageSpider:
        return 'm-spider'
      case DiagramType.Matrix:
        return 'matrix'
      case DiagramType.Bubble:
        return 'bubble'
      case DiagramType.Timeline:
        return 'timeline'
    }
  }

  @Watch('selectedLayout')
  private async selectedLayoutChangedAsync(ctx: DiagramView, old: DiagramView) {
    Vue.nextTick(async () => {
      if (this.visual) {
        await this.visual.setActionAsync(ctx)
      }
    })
    this.$bus.$emit('sidemenu:mode', 'none')
  }

  private async saveAsync(format: string) {
    await this.visual.saveAsync(format)
  }

  private saveAllAsync(format: string) {
    const delay = 1500
    this.selectedLayout = diagramViews.items[0]
    setTimeout(async () => {
      await this.saveAsync(format)
      this.selectedLayout = diagramViews.items[1]
      setTimeout(async () => {
        await this.saveAsync(format)
        this.selectedLayout = diagramViews.items[2]
        setTimeout(async () => {
          await this.saveAsync(format)
          this.selectedLayout = diagramViews.items[3]
          setTimeout(async () => {
            await this.saveAsync(format)
            this.selectedLayout = diagramViews.items[4]
            setTimeout(async () => {
              await this.saveAsync(format)
              this.selectedLayout = diagramViews.items[5]
              setTimeout(async () => {
                await this.saveAsync(format)
                this.selectedLayout = diagramViews.items[6]
                setTimeout(async () => {
                  await this.saveAsync(format)
                  this.selectedLayout = diagramViews.items[7]
                  setTimeout(async () => {
                    await this.saveAsync(format)
                    this.selectedLayout = diagramViews.items[8]
                    setTimeout(async () => {
                      await this.saveAsync(format)
                      this.selectedLayout = diagramViews.items[9]
                      setTimeout(async () => {
                        await this.saveAsync(format)
                      }, delay)
                    }, delay)
                  }, delay)
                }, delay)
              }, delay)
            }, delay)
          }, delay)
        }, delay)
      }, delay)
    }, delay)
  }

  private reload() {
    this.$bus.$emit('reload-spider')
  }

  private openStakeholderAiTool() {
    window.open('https://clavis-api-v2.emergo.dev/', '_blank')
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: Vue) => vm.$bus.$emit('sidemenu:mode', 'none'))
  }

  private mounted() {
    this.reload()
  }
}
